export default {
    agency_key: '',
    mode: '',
    chat_url: '',
    beian: '',
    beian_gn: '',

    address: '北京市大兴区星光影视园A座4层',
    uc_host: 'https://user.cctvclzg.com',
    site_host: 'http://xw.cctvclzg.com',
    special_url: '/',
    site_title: '灿烂中国-软文精准营销平台',
    welcome_title: '灿烂中国 — 软文精准营销平台！',
    site_short_title: '灿烂中国',
    site_subtitle: '软文精准营销平台',
    company_name: '北京虎跃鹰飞文化传媒有限公司',
    copyright: '© 2023 北京虎跃鹰飞文化传媒有限公司',
    logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/230626/08cd264e1606d0a32a5fab1580af1038.png',
    favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/230626/08cd264e1606d0a32a5fab1580af1038.png',
    payment: '',
    qq: '139008218',
    tel: '13366669558',
    company_account_id: '0200097809000090576',
    company_bank: '中国工商银行股份有限公司北京公益桥支行',
    company_bank_name: '北京虎跃鹰飞文化传媒有限公司',
    alipay_account_id: '139008218@qq.com',
    alipay_name: '张虎',
    alipay_pic: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/230705/9830a11c54f71a179041711b85b59e1c.png',
    section_id: 5327478,
    belonger_id: 5327478,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 